import { useMutation, useQueryClient } from "@tanstack/react-query";
import { NotificationsLevel } from "../../../lib/enums";
import api from "../../../services/api";
import { show } from "../../../notifications/notifications";
import { DeleteTagsRequest, DeletedTagResponse } from "../../@types";
import { USER_TAGS_KEY } from "../queryKeys";
import { formatTagNotificationMessage } from "../utils";

const useDeleteTags = () => {
  const deleteTags = (data: DeleteTagsRequest) => api.deleteUserTags(data);
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation({
    mutationFn: deleteTags,
    onSuccess: ({ data }) => {
      queryClient.invalidateQueries({ queryKey: [USER_TAGS_KEY] });
      const deletedTags = data.map(
        (item: DeletedTagResponse) => item.deleted_tag
      );
      const message = formatTagNotificationMessage("Deleted tag", deletedTags);
      show({
        level: NotificationsLevel.INFO,
        message
      });
    },
    onError: () => {
      show({
        level: NotificationsLevel.ERROR,
        message: "Something went wrong. Please try again."
      });
    }
  });

  return { mutate: mutateAsync };
};

export default useDeleteTags;
